/**
 * RefundSlice Extra Reducers
 * 
 * Handles RTK Query endpoint state updates.
 */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { RefundSliceState, initialState } from './state';
import { refundEndpoints } from '../endpoints/refundEndpoints';

export function buildRefundExtraReducers(builder: ActionReducerMapBuilder<RefundSliceState>) {
  builder
    .addMatcher(
      refundEndpoints.endpoints.getRefund.matchFulfilled,
      (state, action) => {
        state.currentRefund = action.payload;
        state.isEdited = false;
        state.editedFields = [];
        state.validationErrors = {};
      }
    );
}
